import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getMenus = async () => {
  const request = `${API_CONSTANT_MAP.menuItens}`;
  return requestApi.get(request);
};
